import { rankings, rankItem } from '@tanstack/match-sorter-utils';

import { OrderFormCategoryDTO, OrderFormProductDTO } from 'support/types';

export const matchesNameOrGTIN = (product: OrderFormProductDTO, term: string): boolean => {
  if (!term.trim()) {
    return false;
  }

  const nameMatch = product.name ? rankItem(product.name, term, { threshold: rankings.MATCHES }) : { passed: false };

  if (nameMatch.passed) {
    return true;
  }

  const productGTIN = product.identifiers?.find((id) => id.domain === 'GTIN')?.value;
  if (productGTIN) {
    const gtinMatch = rankItem(productGTIN, term, { threshold: rankings.CONTAINS });
    return gtinMatch.passed;
  }

  return false;
};

export const filterProductsInCategories = (
  categories: Array<OrderFormCategoryDTO>,
  searchTerm: string,
): Array<OrderFormCategoryDTO> => {
  if (!categories || categories.length === 0) {
    return [];
  }

  if (!searchTerm.trim()) {
    return categories;
  }

  return categories.reduce<Array<OrderFormCategoryDTO>>((filtered, category) => {
    const filteredProducts = category.products.filter((product) => matchesNameOrGTIN(product, searchTerm));

    if (filteredProducts.length === 0) {
      return filtered;
    }

    const filteredCategory = { ...category, products: filteredProducts };
    return [...filtered, filteredCategory];
  }, []);
};
